export default __webpack_public_path__ + "static/media/image.400dd68f.svg";